
import { ControlElement } from '@jsonforms/core';
import { defineComponent } from 'vue';
import { rendererProps, RendererProps, useJsonFormsControl } from '@jsonforms/vue';

const controlRenderer = defineComponent({
  name: 'date-control-renderer',
  props: {
    ...rendererProps<ControlElement>(),
    dateCanBeEdit: { type: Boolean, default: false },
    isNewEl: { type: Boolean, default: false },
    dataElement: { type: Object },
  },
  setup(props: RendererProps<ControlElement>) {
    return useJsonFormsControl(props);
  },
  data() {
    return {
      date: undefined,
      localError: '' as string,
      isTouched: false,
    };
  },
  computed: {
    hasError(): boolean {
      return !!(this.control.errors || this.localError);
    },
    errorMessage(): string {
      if (this.control.errors) {
        return this.control.errors;
      }
      return this.localError;
    },
  },
  methods: {
    onBlur() {
      this.isTouched = true;
    },
    onFocus() {
      // Optionally mark as touched on focus
    },
    validateMinTime(value: string | undefined): boolean {
      if (!value) return true;

      const inputTime = new Date(value).getTime();
      const nowPlusOneHour = Date.now() + 3600000;

      return inputTime >= nowPlusOneHour;
    },
    validatePattern(value: string | undefined): boolean {
      if (!value) return true;
      if (!this.control?.schema?.pattern) return true;

      const pattern = new RegExp(this.control.schema.pattern);
      return pattern.test(value);
    },
    validate(value: string | undefined): void {
      this.localError = '';

      if (!value) {
        return;
      }

      if (!this.validatePattern(value)) {
        this.localError = this.control.schema?.description || 'Invalid date format';
        return;
      }

      if (!this.validateMinTime(value)) {
        this.localError = 'Date/time must be at least 1 hour from now';
        return;
      }
    },
    onDateChange(value: string | undefined) {
      this.isTouched = true;
      this.onChange(value);
    },
    onChange(value: string | undefined) {
      this.validate(value);
      this.handleChange(this.control.path, value || undefined);
    },
  },
  watch: {
    'control.data': {
      handler(newValue) {
        this.validate(newValue);
      },
      immediate: false,
    },
  },
});

export default controlRenderer;
